<script setup lang="ts">
import { useCourseStore } from '../stores/courseStore';
import { format, parseISO } from 'date-fns';
import { de } from 'date-fns/locale';
import TopBar from '../components/TopBar.vue';

const store = useCourseStore();

function formatDate(dateStr: string): string {
  return format(parseISO(dateStr), 'dd. MMMM yyyy', { locale: de });
}
</script>

<template>
  <div>
    <TopBar />
    <div class="past-courses-container">
      <div v-if="store.pastCourses.length === 0" class="no-courses">
        Keine vergangenen Kurse vorhanden
      </div>
      <template v-else>
        <div v-for="(course, index) in store.pastCourses" :key="index">
          <div v-if="index === 0 || course.date !== store.pastCourses[index - 1].date" class="date-separator">
            {{ formatDate(course.date) }}
          </div>
          <div class="course-item">
            <div class="time">{{ course.time }}</div>
            <div class="course-details">
              <div class="name">{{ course.course_name }}</div>
              <div class="room">{{ course.room }}</div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped>
.past-courses-container {
  padding: 1rem;
  margin-top: 48px;
  margin-bottom: 48px;
}

.no-courses {
  text-align: center;
  color: #666;
  padding: 2rem;
}

.date-separator {
  text-align: center;
  margin: 1.5rem 0;
  position: relative;
  color: #960040;
  font-weight: 500;
}

.date-separator::before,
.date-separator::after {
  content: '';
  position: absolute;
  top: 50%;
  width: 30%;
  height: 1px;
  background-color: #ddd;
}

.date-separator::before {
  left: 0;
}

.date-separator::after {
  right: 0;
}

.course-item {
  background: white;
  padding: 1rem;
  margin-bottom: 0.5rem;
  border-radius: 8px;
  display: flex;
  gap: 1rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.time {
  color: #960040;
  font-weight: bold;
  width: 100px;
  flex-shrink: 0;
}

.course-details {
  flex: 1;
}

.name {
  color: #960040;
  font-weight: 500;
  margin-bottom: 0.25rem;
}

.room {
  color: #666;
  font-size: 0.9em;
}
</style>